import styled from 'styled-components'
import { pxToRem } from '@affinidi/component-library'

export const Text = styled.span`
  display: flex;
  flex-direction: column;
  row-gap: ${pxToRem(16)};
`
